import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=56a3c02e&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56a3c02e')) {
      api.createRecord('56a3c02e', component.options)
    } else {
      api.reload('56a3c02e', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=56a3c02e&", function () {
      api.rerender('56a3c02e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2O1d7lCl53ceb/JS/comp/openstreetmap.vue"
export default component.exports